{
  "instances": {
    "configprops": {
      "label": "구성 속성(Configuration Properties)",

      "no_properties_set": "설정된 구성 속성 정보가 없습니다."
    }
  }
}
